import { createContext, useReducer } from "react";
import { clearItemFromStorage, getItemFromStorage, setItemInStorage } from "../../utils/utilsFuncs";

const UserContext = createContext();

let initialState = {
  accountId: getItemFromStorage("accountId") !== null ? getItemFromStorage("accountId") : -1,
  accountName: getItemFromStorage("accountName") !== null ? getItemFromStorage("accountName") : "",
  subscriberId: getItemFromStorage("subscriberId") !== null ? getItemFromStorage("subscriberId") : -1,
  partnerId: getItemFromStorage("partnerId") !== null ? getItemFromStorage("partnerId") : -1,
};

export const ActionType = {
  setAccountId: "setAccountId",
  setAccountName: "setAccountName",
  setSubscriberId: "setSubscriberId",
  setPartnerId: "setPartnerId",
};

function userReducer(state, action) {
  switch (action.type) {
    case ActionType.setAccountId: {
      setItemInStorage("accountId", action.payload.accountId);
      return { ...state, accountId: action.payload.accountId };
    }
    case ActionType.setAccountName: {
      setItemInStorage("accountName", action.payload);
      return { ...state, accountName: action.payload };
    }
    case ActionType.setSubscriberId: {
      if (action.payload === -1) {
        clearItemFromStorage("subscriberId");
        return { ...state, subscriberId: action.payload };
      }
      setItemInStorage("subscriberId", action.payload);
      return { ...state, subscriberId: action.payload };
    }
    case ActionType.setPartnerId: {
      setItemInStorage("partnerId", action.payload.partnerId);
      return { ...state, partnerId: action.payload.partnerId };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  const [state, dispatch] = useReducer(userReducer, initialState);
  const value = { state, dispatch };
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export { UserProvider, UserContext };
